let jQuery = require('jquery');
let cytoscape = require('cytoscape');
require('qtip2');

export function AddGraphTips() {

    let isObject = function (o) {
        return o != null && typeof o === 'object';
    };

    let isFunction = function (o) {
        return o != null && typeof o === 'function';
    };

    let isNumber = function (o) {
        return o != null && typeof o === 'number';
    };

    let isString = function (o) {
        return o != null && typeof o === 'string';
    };

    let isUndef = function (o) {
        return o === undefined;
    };

    let wrap = function (obj, target, context) {
        if (isFunction(obj)) {
            return function (event, api) {
                return obj.apply(target, [event, api, context]);
            };
        } else {
            return obj;
        }
    };

    let debounce = function (func, wait, options) { // ported lodash debounce function
        let args,
            maxTimeoutId,
            result,
            stamp,
            thisArg,
            timeoutId,
            trailingCall,
            lastCalled = 0,
            maxWait: any = false,
            trailing = true;

        if (!isFunction(func)) {
            return;
        }
        wait = Math.max(0, wait) || 0;
        let leading = true;
        if (options === true) {
            leading = true;
            trailing = false;
        } else if (isObject(options)) {
            leading = options.leading;
            maxWait = 'maxWait' in options && (Math.max(wait, options.maxWait) || 0);
            trailing = 'trailing' in options ? options.trailing : trailing;
        }
        let delayed = function () {
            let remaining = wait - (Date.now() - stamp);
            if (remaining <= 0) {
                if (maxTimeoutId) {
                    clearTimeout(maxTimeoutId);
                }
                let isCalled = trailingCall;
                maxTimeoutId = timeoutId = trailingCall = undefined;
                if (isCalled) {
                    lastCalled = Date.now();
                    result = func.apply(thisArg, args);
                    if (!timeoutId && !maxTimeoutId) {
                        args = thisArg = null;
                    }
                }
            } else {
                timeoutId = setTimeout(delayed, remaining);
            }
        };

        let maxDelayed = function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            maxTimeoutId = timeoutId = trailingCall = undefined;
            if (trailing || (maxWait !== wait)) {
                lastCalled = Date.now();
                result = func.apply(thisArg, args);
                if (!timeoutId && !maxTimeoutId) {
                    args = thisArg = null;
                }
            }
        };

        return function () {
            args = arguments;
            stamp = Date.now();
            thisArg = this;
            trailingCall = trailing && (timeoutId || !leading);
            let leadingCall, isCalled;

            if (maxWait === false) {
                leadingCall = leading && !timeoutId;
            } else {
                if (!maxTimeoutId && !leading) {
                    lastCalled = stamp;
                }
                let remaining = maxWait - (stamp - lastCalled);
                isCalled = remaining <= 0;

                if (isCalled) {
                    if (maxTimeoutId) {
                        maxTimeoutId = clearTimeout(maxTimeoutId);
                    }
                    lastCalled = stamp;
                    result = func.apply(thisArg, args);
                } else if (!maxTimeoutId) {
                    maxTimeoutId = setTimeout(maxDelayed, remaining);
                }
            }
            if (isCalled && timeoutId) {
                timeoutId = clearTimeout(timeoutId);
            } else if (!timeoutId && wait !== maxWait) {
                timeoutId = setTimeout(delayed, wait);
            }
            if (leadingCall) {
                isCalled = true;
                result = func.apply(thisArg, args);
            }
            if (isCalled && !timeoutId && !maxTimeoutId) {
                args = thisArg = null;
            }
            return result;
        };
    };

    let throttle = function (func, wait, options) {
        let leading = true,
            trailing = true;

        if (options === false) {
            leading = false;
        } else if (isObject(options)) {
            leading = 'leading' in options ? options.leading : leading;
            trailing = 'trailing' in options ? options.trailing : trailing;
        }
        options = options || {};
        options.leading = leading;
        options.maxWait = wait;
        options.trailing = trailing;

        return debounce(func, wait, options);
    };

    function register(cyto, $) {

        // use a single dummy dom ele as target for every qtip
        let $qtipContainer = jQuery('<div></div>');
        let viewportDebounceRate = 250;

        function generateOpts(target, passedOpts) {
            let qtip = target.scratch().qtip;
            let opts = jQuery.extend({}, passedOpts);

            if (!opts.id) {
                opts.id = 'cy-qtip-target-' + ( Date.now() + Math.round(Math.random() * 10000) );
            }

            if (!qtip.$domEle) {
                qtip.$domEle = $qtipContainer;
            }

            // qtip should be positioned relative to cy dom container
            opts.position = opts.position || {};
            opts.position.container = opts.position.container || $('app');
            opts.position.viewport = opts.position.viewport || $('app');
            opts.position.target = [0, 0];
            opts.position.my = opts.position.my || 'top center';
            opts.position.at = opts.position.at || 'bottom center';

            // adjust
            let adjust = opts.position.adjust = opts.position.adjust || {};
            adjust.method = adjust.method || 'flip';
            adjust.mouse = false;

            if (isUndef(adjust.cyAdjustToEleBB)) {
                adjust.cyAdjustToEleBB = true;
            }

            // default show event
            opts.show = opts.show || {};

            if (isUndef(opts.show.event)) {
                opts.show.event = 'tap';
            }

            // default hide event
            opts.hide = opts.hide || {};
            opts.hide.cyViewport = opts.hide.cyViewport === undefined ? true : opts.hide.cyViewport;

            if (isUndef(opts.hide.event)) {
                opts.hide.event = 'unfocus';
            }

            // so multiple qtips can exist at once (only works on recent qtip2 versions)
            opts.overwrite = false;

            if (opts.content) {
                if (isFunction(opts.content) || isString(opts.content)) {
                    opts.content = wrap(opts.content, target, opts.context);
                } else {
                    opts.content = {
                        text: wrap(opts.content.text, target, opts.context),
                        title: wrap(opts.content.title, target, opts.context)
                    };
                }
            }

            return opts;
        }

        cyto('collection', 'GraphTips', function (passedOpts) {
            let eles = this;
            let cy = this.cy();
            let container = cy.container();

            if (passedOpts === 'api') {
                return this.scratch().qtip.api;
            }

            eles.each(function (i, ele) {
                let scratch = ele.scratch();
                let qtip = scratch.qtip = scratch.qtip || {};
                let opts = generateOpts(ele, passedOpts);
                let adjNums = opts.position.adjust;


                qtip.$domEle.qtip(opts);
                let qtipApi = qtip.api = qtip.$domEle.qtip('api'); // save api ref
                qtip.$domEle.removeData('qtip'); // remove qtip dom/api ref to be safe

                let updatePosition = function (e) {
                    let cOff = container.getBoundingClientRect();
                    let pos = ele.renderedPosition() || ( e ? e.cyRenderedPosition : undefined );
                    if (!pos || pos.x == null || isNaN(pos.x)) {
                        return;
                    }

                    if (opts.position.adjust.cyAdjustToEleBB && ele.isNode()) {
                        let my = opts.position.my.toLowerCase();
                        let at = opts.position.at.toLowerCase();
                        let z = cy.zoom();
                        let w = ele.outerWidth() * z;
                        let h = ele.outerHeight() * z;

                        if (at.match('top')) {
                            pos.y -= h / 2;
                        } else if (at.match('bottom')) {
                            pos.y += h / 2;
                        }

                        if (at.match('left')) {
                            pos.x -= w / 2;
                        } else if (at.match('right')) {
                            pos.x += w / 2;
                        }

                        if (isNumber(adjNums.x)) {
                            pos.x += adjNums.x;
                        }

                        if (isNumber(adjNums.y)) {
                            pos.y += adjNums.y;
                        }
                    }

                    qtipApi.set('position.adjust.x', cOff.left + pos.x + window.pageXOffset);
                    qtipApi.set('position.adjust.y', cOff.top + pos.y + window.pageYOffset);
                };

                updatePosition(null);

                ele.on(opts.show.event, function (e) {
                    updatePosition(e);

                    qtipApi.show();
                });

                ele.on(opts.hide.event, function (e) {
                    qtipApi.hide();
                });

                if (opts.hide.cyViewport) {
                    cy.on('viewport', debounce(function () {
                        qtipApi.hide();
                    }, viewportDebounceRate, {leading: true}));
                }

                if (opts.position.adjust.cyViewport) {
                    cy.on('pan zoom', debounce(function (e) {
                        updatePosition(e);

                        qtipApi.reposition();
                    }, viewportDebounceRate, {trailing: true}));
                }

            });

            return this; // chainability

        });

        cyto('core', 'qtip', function (passedOpts) {
            let cy = this;
            let container = cy.container();

            if (passedOpts === 'api') {
                return this.scratch().qtip.api;
            }

            let scratch = cy.scratch();
            let qtip = scratch.qtip = scratch.qtip || {};
            let opts = generateOpts(cy, passedOpts);


            qtip.$domEle.qtip(opts);
            let qtipApi = qtip.api = qtip.$domEle.qtip('api'); // save api ref
            qtip.$domEle.removeData('qtip'); // remove qtip dom/api ref to be safe

            let updatePosition = function (e) {
                let cOff = container.getBoundingClientRect();
                let pos = e.cyRenderedPosition;
                if (!pos || pos.x == null || isNaN(pos.x)) {
                    return;
                }

                qtipApi.set('position.adjust.x', cOff.left + pos.x + window.pageXOffset);
                qtipApi.set('position.adjust.y', cOff.top + pos.y + window.pageYOffset);
            };

            cy.on(opts.show.event, function (e) {
                if (!opts.show.cyBgOnly || (opts.show.cyBgOnly && e.cyTarget === cy)) {
                    updatePosition(e);
                    qtipApi.show();
                }
            });

            cy.on(opts.hide.event, function (e) {
                if (!opts.hide.cyBgOnly || (opts.hide.cyBgOnly && e.cyTarget === cy)) {
                    qtipApi.hide();
                }
            });

            if (opts.hide.cyViewport) {
                cy.on('viewport', debounce(function () {
                    qtipApi.hide();
                }, viewportDebounceRate, {leading: true}));
            }

            return this;

        });

    }

    register(cytoscape, jQuery);
}



// WEBPACK FOOTER //
// ./src/common/vca-graph/vca-graph-qtip.cytoscape.ts